import store from '@/store';
import { isMobileLayout } from '@/utils/mobile-detection';

const isMobileView = () => isMobileLayout() || store.getters['CommonStore/isMobileApp'];

// Pulse home is desktop-only. On mobile, keep the original dashboard home instead of Pulse.
// (The dashboard route only bounces back to /home on desktop, so this can't loop.)
const redirectToDashboardOnMobile = (to, from, next) => {
  if (isMobileView()) {
    next({ name: 'dashboard' });
  } else {
    next();
  }
};

const routes = [
  {
    path: '/home',
    name: 'home',
    component: () => import(/* webpackChunkName: "PulseFeed" */ './views/HomeView.vue'),
    meta: { i18n: 'pulse-pov', pageNameEn: 'Home' },
    beforeEnter: redirectToDashboardOnMobile,
  },
];

export default routes;
